var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12, _path13, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _circle, _circle2, _rect17, _rect18, _rect19, _rect20, _rect21, _circle3, _circle4, _rect22, _rect23, _rect24, _rect25, _rect26, _circle5, _circle6, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _ellipse, _ellipse2, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1085,
    height: 411,
    viewBox: "0 0 1085 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1039.93 268H281.469C167.91 268 104.426 270.056 68.9555 272.41C44.8935 274.007 -14.7 298.811 5.67737 311.707C25.4679 324.231 59.9504 321.806 132.57 340.431C173.428 350.911 164.338 381.821 223.598 394.291C284.354 407.075 396.802 395.262 474.688 399.862C573.64 405.707 662.004 419.678 752.658 403.32C843.311 386.962 889.867 348.768 944.131 334.71C993.906 321.816 1121.03 304.19 1075.21 275.916C1064.82 269.502 1052.14 268 1039.93 268Z",
    fill: "#D0E9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M463.357 310.354L485.707 306.056C485.898 306.02 486.096 306.04 486.276 306.114L585.296 346.916C585.43 346.971 585.575 346.997 585.72 346.99L677.541 343.02C677.832 343.007 678.115 343.122 678.314 343.335L684.115 349.523C684.682 350.127 684.309 351.119 683.485 351.202L585.743 360.976C585.583 360.992 585.422 360.969 585.273 360.91L463.176 312.265C462.248 311.896 462.376 310.543 463.357 310.354Z",
    fill: "#8AC8B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M624 173.5L635 170.5L675.606 324.374L664.642 327.284L624 173.5Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M586 324.429L699 313L682.756 348.714L586 358V324.429Z",
    fill: "#222830"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M470 296L586 324.775V358L477.117 315.241L470 305.264V296Z",
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M565.003 287L699 313.037L586.981 325L470 296.148L565.003 287Z",
    fill: "#504F4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M299.309 132.251C299.268 131.641 299.83 131.165 300.425 131.307L446.937 166.157C447.729 166.346 448.216 167.144 448.022 167.935C447.829 168.721 447.034 169.203 446.247 169.009L299.999 133.072C299.615 132.977 299.336 132.645 299.309 132.251Z",
    fill: "#C6E6F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M346.431 196.254C346.431 195.668 346.978 195.235 347.548 195.369L460.227 221.911C461.02 222.098 461.508 222.896 461.314 223.687C461.121 224.473 460.327 224.954 459.541 224.761L347.123 197.136C346.717 197.036 346.431 196.672 346.431 196.254Z",
    fill: "#C6E6F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M387.364 88.1785C387.399 87.617 387.93 87.2216 388.478 87.3487L470.561 106.381C471.355 106.565 471.846 107.363 471.651 108.155C471.459 108.94 470.666 109.42 469.881 109.227L388.055 89.1195C387.627 89.0144 387.336 88.6181 387.364 88.1785Z",
    fill: "#C6E6F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M291.229 90.1885C291.228 89.8793 291.516 89.6504 291.817 89.7213L351.923 103.887C352.34 103.986 352.597 104.406 352.495 104.822C352.393 105.236 351.975 105.489 351.561 105.388L291.593 90.6516C291.38 90.5992 291.229 90.4082 291.229 90.1885Z",
    fill: "#C6E6F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M604.946 88.1041L608.466 89.512C610.499 90.3251 611.927 92.1807 612.194 94.3537L614.497 113.169C615.078 117.912 620.698 120.106 624.339 117.012L643.113 101.054",
    stroke: "#2D2D2B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 512.256,
    y: 6.99997,
    width: 98.1429,
    height: 186.744,
    fill: "#F3F2F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M512.256 193.744H610.399L594.042 201.923H495.899L512.256 193.744Z",
    fill: "#848381"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M495.899 15.3082L512.256 6.99997V193.744L495.899 201.923L495.899 15.3082Z",
    fill: "#AFAEAC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 517.709,
    y: 107.869,
    width: 87.2381,
    height: 4.08929,
    rx: 1,
    fill: "#CCCBC9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 517.709,
    y: 124.226,
    width: 87.2381,
    height: 4.08929,
    rx: 1,
    fill: "#CCCBC9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 517.709,
    y: 140.583,
    width: 87.2381,
    height: 4.08929,
    rx: 1,
    fill: "#CCCBC9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 517.709,
    y: 156.94,
    width: 87.2381,
    height: 4.08929,
    rx: 1,
    fill: "#CCCBC9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 517.709,
    y: 173.298,
    width: 87.2381,
    height: 4.08929,
    rx: 1,
    fill: "#CCCBC9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 517.709,
    y: 116.048,
    width: 87.2381,
    height: 4.08929,
    rx: 1,
    fill: "#CCCBC9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 517.709,
    y: 132.405,
    width: 87.2381,
    height: 4.08929,
    rx: 1,
    fill: "#CCCBC9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 517.709,
    y: 148.762,
    width: 87.2381,
    height: 4.08929,
    rx: 1,
    fill: "#CCCBC9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 517.709,
    y: 165.119,
    width: 87.2381,
    height: 4.08929,
    rx: 1,
    fill: "#CCCBC9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 517.709,
    y: 181.476,
    width: 87.2381,
    height: 4.08929,
    rx: 1,
    fill: "#CCCBC9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 517.709,
    y: 17.9047,
    width: 87.2381,
    height: 24.5357,
    rx: 2,
    fill: "#CCCBC9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 595.405,
    y: 21.994,
    width: 5.45238,
    height: 17.7202,
    rx: 2.72619,
    fill: "#8AC8B2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 587.226,
    y: 21.994,
    width: 5.45238,
    height: 17.7202,
    rx: 2.72619,
    fill: "#8AC8B2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 579.048,
    y: 21.994,
    width: 5.45238,
    height: 17.7202,
    rx: 2.72619,
    fill: "#8AC8B2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 570.869,
    y: 21.994,
    width: 5.45238,
    height: 17.7202,
    rx: 2.72619,
    fill: "#8AC8B2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 528.613,
    cy: 24.7202,
    r: 2.72619,
    fill: "#DFA464"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 535.429,
    cy: 24.7202,
    r: 2.72619,
    fill: "#D97872"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 517.709,
    y: 47.8928,
    width: 87.2381,
    height: 24.5357,
    rx: 2,
    fill: "#CCCBC9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 595.405,
    y: 51.9821,
    width: 5.45238,
    height: 17.7202,
    rx: 2.72619,
    fill: "#8AC8B2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 587.226,
    y: 51.9821,
    width: 5.45238,
    height: 17.7202,
    rx: 2.72619,
    fill: "#8AC8B2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 579.048,
    y: 51.9821,
    width: 5.45238,
    height: 17.7202,
    rx: 2.72619,
    fill: "#8AC8B2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 570.869,
    y: 51.9821,
    width: 5.45238,
    height: 17.7202,
    rx: 2.72619,
    fill: "#8AC8B2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.613,
    cy: 54.7083,
    r: 2.72619,
    fill: "#DFA464"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 535.429,
    cy: 54.7083,
    r: 2.72619,
    fill: "#D97872"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 517.709,
    y: 77.8809,
    width: 87.2381,
    height: 24.5357,
    rx: 2,
    fill: "#CCCBC9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 595.405,
    y: 81.9702,
    width: 5.45238,
    height: 17.7202,
    rx: 2.72619,
    fill: "#8AC8B2"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 587.226,
    y: 81.9702,
    width: 5.45238,
    height: 17.7202,
    rx: 2.72619,
    fill: "#8AC8B2"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 579.048,
    y: 81.9702,
    width: 5.45238,
    height: 17.7202,
    rx: 2.72619,
    fill: "#8AC8B2"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 570.869,
    y: 81.9702,
    width: 5.45238,
    height: 17.7202,
    rx: 2.72619,
    fill: "#8AC8B2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.613,
    cy: 86.0595,
    r: 2.72619,
    fill: "#8AC8B2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 535.429,
    cy: 86.0595,
    r: 2.72619,
    fill: "#8AC8B2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M570.869 201.923L586.505 234.445C587.421 236.35 587.768 238.478 587.506 240.576L582.584 279.957C582.085 283.95 583.806 287.897 587.071 290.249L598.813 298.702",
    stroke: "#2D2D2B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M540.201 201.923L538.688 231.693C538.39 237.543 533.56 242.134 527.702 242.134H523.94C518.723 242.134 514.224 245.797 513.168 250.905L510.893 261.899",
    stroke: "#2D2D2B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M502.033 88.1041L495.664 88.7756C494.044 88.9464 492.563 89.7685 491.562 91.053L477.867 108.615C476.141 110.829 476.18 113.944 477.962 116.113L495.684 137.686",
    stroke: "#2D2D2B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.267 263.916L502.814 266.056L503.998 288.045C504.353 289.676 505.317 291.209 506.496 292.552C510.204 296.775 516.633 297.193 520.857 293.486C522.565 291.986 523.651 290.041 524.093 287.977C523.524 289.265 522.679 290.449 521.56 291.431C517.337 295.139 510.908 294.721 507.2 290.497C506.021 289.154 505.056 287.622 504.701 285.991L503.267 263.916Z",
    fill: "#CCCBC9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.267 254.174C505.388 253.6 505.934 253.219 506.515 253.304C507.288 255.669 508.346 257.587 510.884 258.448C512.913 259.135 515.023 258.981 516.836 258.173L522.592 277.722C522.735 278.207 522.959 278.663 523.207 279.104C525.533 283.221 524.822 288.64 521.138 291.873C516.915 295.581 510.485 295.163 506.778 290.94C505.598 289.596 504.634 288.064 504.279 286.433L503.095 264.443L505.267 254.174Z",
    fill: "#FAF9F8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M509.192 257.833C509.147 257.481 509.292 257.13 509.6 256.953C510.297 256.554 511.652 255.963 513.003 256.421C514.394 256.893 515.339 257.584 515.761 257.936C515.929 258.076 516.027 258.277 516.056 258.493L518.252 275.012C518.325 275.559 517.941 276.061 517.394 276.135L512.626 276.775C512.077 276.849 511.572 276.461 511.501 275.911L509.192 257.833Z",
    fill: "#CCCBC9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M509.498 262.745C509.498 262.745 511.602 263.166 512.957 263.08C514.506 262.982 516.811 262.111 516.811 262.111",
    stroke: "#F3F2F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M509.71 265.261C509.71 265.261 511.814 265.682 513.169 265.596C514.718 265.498 517.023 264.627 517.023 264.627",
    stroke: "#F3F2F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M509.939 267.977C509.939 267.977 512.043 268.399 513.398 268.313C514.946 268.215 517.252 267.344 517.252 267.344",
    stroke: "#F3F2F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M510.168 270.694C510.168 270.694 512.272 271.115 513.627 271.029C515.175 270.931 517.481 270.06 517.481 270.06",
    stroke: "#F3F2F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M510.396 273.41C510.396 273.41 512.501 273.832 513.855 273.746C515.404 273.648 517.71 272.777 517.71 272.777",
    stroke: "#F3F2F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M575.5 291L575.5 292.5L588.476 303.663L603.903 312.771C604.285 312.537 604.651 312.279 605 312L589.138 302.576L575.5 291Z",
    fill: "#CCCBC9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M575.472 291.452L576.52 281.3C578.15 282.81 580.266 283.823 582.647 284.069C585.106 284.323 586.781 283.781 588.723 282.559L595.931 290.849C597.596 292.764 599.927 293.975 602.451 294.235L602.785 294.27C603.628 294.357 604.458 294.603 605.139 295.109C608.244 297.417 610.089 301.256 609.663 305.384C609.31 308.811 607.933 310.222 605.365 311.86C605.051 312.06 604.651 312.062 604.331 311.871L588.66 302.524L575.472 291.452Z",
    fill: "#FAF9F8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M583.961 284.922C583.8 284.746 583.705 284.517 583.745 284.282C583.836 283.759 584.16 282.783 585.318 282.055C586.654 281.216 587.118 281.361 587.247 281.448C587.28 281.47 587.303 281.503 587.329 281.532L593.362 288.644L597.735 292.931C598.161 293.349 598.129 294.045 597.666 294.421L595.527 296.16C595.116 296.494 594.516 296.45 594.158 296.06L583.961 284.922Z",
    fill: "#CCCBC9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M589.327 283.153L587.639 283.545C586.719 283.759 585.954 284.394 585.573 285.258L584.874 286.844",
    stroke: "#EEEDEA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M591.038 285.274L589.351 285.667C588.431 285.881 587.666 286.515 587.285 287.379L586.586 288.965",
    stroke: "#EEEDEA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M592.75 287.396L591.063 287.789C590.143 288.002 589.377 288.637 588.997 289.501L588.298 291.087",
    stroke: "#EEEDEA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M594.462 289.518L592.775 289.91C591.855 290.124 591.089 290.759 590.709 291.623L590.01 293.208",
    stroke: "#EEEDEA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M596.174 291.639C595.668 291.757 595.044 291.902 594.486 292.032C593.567 292.246 592.801 292.88 592.421 293.744L591.722 295.33",
    stroke: "#EEEDEA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M519.861 173.437L530.658 170.571L572.095 324.374L561.298 327.24L519.861 173.437Z",
    fill: "#111111"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M508.285 160.768V151.551L555.077 137.372L600.452 114.684L693.328 123.901V137.372L669.223 160.768L635.192 163.604V170.694L623.848 173.53L615.341 165.022L622.43 151.551L669.223 150.133L682.693 136.209L602.579 127.446L557.913 150.133L530.263 157.932L530.972 170.694L519.628 173.53L508.285 160.768Z",
    fill: "#111111"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M602.5 127.5L600.5 114.5L693.5 124V137.5L602.5 127.5Z",
    fill: "#485E77"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M632.946 20.3067C634.18 20.9262 634.678 22.4287 634.059 23.6626C633.439 24.8965 631.936 25.3946 630.703 24.7751C629.469 24.1555 625.122 19.1755 625.122 19.1755C625.122 19.1755 631.712 19.6871 632.946 20.3067Z",
    fill: "#A6D6E8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M630.258 23.4327C630.258 23.4327 631.012 24.0923 631.598 24.1057C632.302 24.1219 633.165 23.2139 633.165 23.2139",
    stroke: "#E8F6FA",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M480.187 5.44919C479.121 4.5717 478.968 2.99618 479.846 1.93017C480.723 0.864161 482.299 0.711332 483.365 1.58882C484.431 2.46631 487.566 8.2855 487.566 8.2855C487.566 8.2855 481.253 6.32668 480.187 5.44919Z",
    fill: "#A6D6E8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M482.177 5.26323C482.177 5.26323 481.202 5.03 480.852 4.56042C480.431 3.99605 480.671 2.76671 480.671 2.76671",
    stroke: "#E8F6FA",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M632.341 5.51179C633.693 5.22912 635.017 6.09555 635.3 7.44701C635.583 8.79848 634.716 10.1232 633.365 10.4059C632.013 10.6886 625.512 9.4943 625.512 9.4943C625.512 9.4943 630.99 5.79446 632.341 5.51179Z",
    fill: "#A6D6E8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M632.181 9.63178C632.181 9.63178 633.183 9.67853 633.649 9.32469C634.211 8.89943 634.321 7.65173 634.321 7.65173",
    stroke: "#E8F6FA",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M477.5 19.0422C476.119 19.0185 475.019 17.8801 475.043 16.4996C475.067 15.1191 476.205 14.0192 477.586 14.0429C478.966 14.0667 485.041 16.6715 485.041 16.6715C485.041 16.6715 478.88 19.0659 477.5 19.0422Z",
    fill: "#A6D6E8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M478.766 17.7793C478.766 17.7793 477.822 18.1187 477.272 17.9179C476.611 17.6766 476.138 16.5167 476.138 16.5167",
    stroke: "#E8F6FA",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M499 258C498.7 258.333 498.271 259.181 498.1 259.75C497.875 260.5 498.1 262.167 498.1 263",
    stroke: "#2D2D2B",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M610.907 297.167C610.834 296.724 610.5 295.266 610 294.766C609.226 293.992 608.5 293.766 607.562 293.344",
    stroke: "#2D2D2B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M611.641 294.449C611.598 294.189 611.402 293.332 611.108 293.038C610.653 292.583 610.226 292.45 609.675 292.202",
    stroke: "#2D2D2B",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M501 258C500.7 258.533 500.271 259.889 500.1 260.8C499.875 262 500.1 264.667 500.1 266",
    stroke: "#2D2D2B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.52,
    cx: 314,
    cy: 352.5,
    rx: 42,
    ry: 7.5,
    fill: "#8AC8B2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.35,
    cx: 769.5,
    cy: 296.5,
    rx: 30.5,
    ry: 4.5,
    fill: "#8AC8B2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M331 330H295V338H331V330Z",
    fill: "#222830"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M280.887 353.731C278.188 353.731 276 351.541 276 348.846V318.892C276 316.194 278.189 314.007 280.887 314.007C283.584 314.007 285.773 316.194 285.773 318.892V348.846C285.773 351.542 283.584 353.731 280.887 353.731Z",
    fill: "#222830"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M290.887 357.871C288.187 357.871 286 355.682 286 352.983V314.886C286 312.188 288.188 310 290.887 310C293.586 310 295.773 312.189 295.773 314.886V352.982C295.774 355.682 293.586 357.871 290.887 357.871Z",
    fill: "#222830"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M275.637 329.23C273.549 329.784 272 331.671 272 333.936C272 336.2 273.549 338.086 275.637 338.64V329.23Z",
    fill: "#222830"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M345.906 314.14C348.606 314.14 350.791 316.329 350.791 319.027V348.98C350.791 351.678 348.604 353.866 345.906 353.866C343.207 353.866 341.02 351.677 341.02 348.98V319.027C341.02 316.328 343.207 314.14 345.906 314.14Z",
    fill: "#222830"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M335.886 310C338.586 310 340.774 312.189 340.774 314.888V352.986C340.774 355.683 338.584 357.871 335.886 357.871C333.189 357.871 331 355.682 331 352.986V314.888C330.999 312.189 333.189 310 335.886 310Z",
    fill: "#222830"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M351.02 338.64C353.11 338.086 354.658 336.2 354.658 333.936C354.658 331.671 353.11 329.784 351.02 329.23V338.64Z",
    fill: "#222830"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M782.409 278.715H755.922V284.601H782.409V278.715Z",
    fill: "#222830"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M745.538 296.175C743.553 296.175 741.943 294.563 741.943 292.58V270.542C741.943 268.557 743.553 266.948 745.538 266.948C747.523 266.948 749.134 268.557 749.134 270.542V292.58C749.134 294.564 747.523 296.175 745.538 296.175Z",
    fill: "#222830"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M752.896 299.221C750.909 299.221 749.3 297.61 749.3 295.625V267.594C749.3 265.61 750.91 264 752.896 264C754.881 264 756.491 265.61 756.491 267.594V295.624C756.492 297.61 754.881 299.221 752.896 299.221Z",
    fill: "#222830"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M741.676 278.148C740.14 278.556 739 279.944 739 281.61C739 283.276 740.14 284.664 741.676 285.072V278.148Z",
    fill: "#222830"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M793.375 267.046C795.362 267.046 796.97 268.656 796.97 270.641V292.679C796.97 294.664 795.361 296.274 793.375 296.274C791.39 296.274 789.781 294.663 789.781 292.679V270.641C789.781 268.656 791.39 267.046 793.375 267.046Z",
    fill: "#222830"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M786.003 264C787.99 264 789.6 265.61 789.6 267.596V295.626C789.6 297.611 787.989 299.221 786.003 299.221C784.019 299.221 782.409 297.61 782.409 295.626V267.596C782.408 265.61 784.019 264 786.003 264Z",
    fill: "#222830"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M797.138 285.072C798.676 284.664 799.815 283.276 799.815 281.61C799.815 279.944 798.676 278.556 797.138 278.148V285.072Z",
    fill: "#222830"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.4c3fc8826c6b2570bc6a5521ffff47c6.svg";
export { ForwardRef as ReactComponent };